'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const partial = require('lodash.partial');
const Tooltip = require('dibs-react-tooltip');
require('dibs-react-tooltip/dist/main.css');
const root = require('bunsen/helpers/windowCheck');
const mobileCheck = require('bunsen/helpers/mobileCheck');
const ContextComponent = require('../../global/components/ContextComponent');
const CloseIcon = require('dibs-vg/dist/react/close');
const calloutActions = require('./calloutActions');
const css = require('./Callout.scss');

class Callout extends ContextComponent {
    constructor(props) {
        super(props);
        const calloutType = props.callout[props.type];

        this.state = {
            isOpen: calloutType && calloutType.isOpen,
        };

        this._handleClick = this._handleClick.bind(this);
        this._handleScroll = this._handleScroll.bind(this);
        this._handleCloseClick = this._handleCloseClick.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const calloutType = nextProps.callout[nextProps.type];
        this.setState({ isOpen: calloutType && calloutType.isOpen });
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.isOpen && this.state.isOpen) {
            this._openTooltip();
        } else if (prevState.isOpen && !this.state.isOpen) {
            this._removeCloseListeners();
        }
    }

    _removeCloseListeners() {
        root.removeEventListener('click', this._handleClick);
        root.removeEventListener('scroll', this._handleScroll);
    }

    _addCloseListeners() {
        this._handleScroll = partial(this._handleScroll, this.props.scrollToClose);

        if (this.props.scrollToClose > 0) {
            root.addEventListener('scroll', this._handleScroll);
        }

        if (this._handleScroll()) {
            root.addEventListener('click', this._handleClick);
        }
    }

    _handleClick(event) {
        if (this._callout && !this._callout.contains(event.target)) {
            this._closeTooltip();
        }
    }

    _handleScroll(scrollToClose) {
        if (root.pageYOffset >= scrollToClose && scrollToClose !== 0) {
            this._closeTooltip();
            return false;
        }
        return true;
    }

    _openTooltip() {
        const { type, onOpen } = this.props;
        this._addCloseListeners();
        onOpen(type);
    }

    _closeTooltip() {
        const { type } = this.props;
        this.context.executeAction(calloutActions.closeCallout, { type });
    }

    _handleCloseClick(event) {
        const { onCloseClick } = this.props;
        event.preventDefault();
        if (onCloseClick) {
            onCloseClick();
        }
        this._closeTooltip();
        this.context.executeAction(calloutActions.stopCallouts);
    }

    _getMobileContent() {
        const { localCss } = this.props;
        return <div className={localCss.content}>{this.props.copy.mobileText}</div>;
    }

    _getContent() {
        const { localCss } = this.props;
        const { header, text } = this.props.copy;
        return (
            <div
                ref={callout => {
                    this._callout = callout;
                }}
            >
                <div className={localCss.title || css.title}>{header}</div>
                <div className={css.divider} />
                <div>{text}</div>
                <a
                    href="#0"
                    className={localCss.close || css.close}
                    onClick={this._handleCloseClick}
                    data-tn="callout-close"
                >
                    <CloseIcon className={localCss.closeButton || css.closeButton} />
                </a>
            </div>
        );
    }

    _getTooltipContent() {
        if (mobileCheck.any() && this.props.copy.mobileText) {
            return this._getMobileContent();
        }
        return this._getContent();
    }

    render() {
        const { isOpen } = this.state;
        const { direction, lockDirection, localCss } = this.props;

        return (
            <Tooltip
                isVisible={isOpen}
                tooltipDirection={direction}
                lockDirection={lockDirection}
                containerClass={localCss.tooltipContainer || css.tooltipContainer}
                triangleClass={localCss.triangle || css.triangle}
                hasShadow
            >
                {this._getTooltipContent()}
            </Tooltip>
        );
    }
}

Callout.propTypes = {
    type: PropTypes.string.isRequired,
    direction: PropTypes.string,
    lockDirection: PropTypes.bool,
    scrollToClose: PropTypes.number, // scroll pixels to close tooltip
    onOpen: PropTypes.func,
    copy: PropTypes.shape({
        header: PropTypes.string,
        text: PropTypes.string,
        mobileText: PropTypes.string,
    }),
    callout: PropTypes.object,
    localCss: PropTypes.object,
};

Callout.defaultProps = {
    direction: 'top',
    lockDirection: false,
    scrollToClose: 0,
    onOpen() {},
    copy: { header: '', text: '' },
    callout: {},
    localCss: {},
};

module.exports = Callout;



// WEBPACK FOOTER //
// ./assets/js/components/Callout/Callout.jsx